import React from "react";
import UserRole from "../components/pages/UserRole/UserRole";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const UserRoleLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <UserRole />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default UserRoleLayout;
